// Initialize OpenTelemetry Tracing asynchronously
import "./tracing";

import React from "react";
import { createRoot } from "react-dom/client";

// Silence Three.js initialization messages
const originalLog = console.log;
console.log = (...args) => {
    if (typeof args[0] === 'string' && args[0].includes('THREE.WebGLRenderer')) return;
    originalLog(...args);
};

import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from "./contexts/AuthContext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);
